module.exports = __webpack_public_path__ + "static/media/04.19bf36e2.jpg";